import { useMutation, useQuery } from "@tanstack/react-query";
import { createQuotePreview, fetchPaymentCapabilities } from "./api";

const Keys = {
  paymentCapabilities: (venueId) => ["paymentCapabilities", venueId],
};

export function useGetPaymentCapabilities(venueId) {
  return useQuery(
    Keys.paymentCapabilities(venueId),
    () => fetchPaymentCapabilities(venueId),
    { useErrorBoundary: true }
  );
}

export function useCreateQuotePreview() {
  return useMutation((quote) => createQuotePreview(quote), {
    useErrorBoundary: true,
  });
}
